import { render, staticRenderFns } from "./DiscoveryPanel.vue?vue&type=template&id=9b1ce468&scoped=true"
import script from "./DiscoveryPanel.vue?vue&type=script&lang=js"
export * from "./DiscoveryPanel.vue?vue&type=script&lang=js"
import style0 from "./DiscoveryPanel.vue?vue&type=style&index=0&id=9b1ce468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1ce468",
  null
  
)

export default component.exports